var map = {
	"./status-available.svg": 47256,
	"./status-away.svg": 68409,
	"./status-brb.svg": 78511,
	"./status-busy.svg": 31712,
	"./status-dnd.svg": 92275,
	"./status-offline.svg": 46376
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44051;